/* eslint-disable import/no-anonymous-default-export */
import NoSsrWrapper from '@packages/common-ui/components/NoSsrWrapper/NoSsrWrapper';
import { LandingPage } from '#components/landing/LandingPage';
export default () => <NoSsrWrapper>
    <LandingPage />
  </NoSsrWrapper>;